import $ from "jquery"

$('.js-how-item').each(function() {
    $(this).on('click', function() {
        $('.how__item').removeClass('how__item--active');
        $(this).closest('.how__item').toggleClass('how__item--active');
    });
});